import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SetValue } from './form-builder.actions';

@State<any>({ name: 'formBuilder' })
@Injectable()
export class FormBuilderState {
  @Action(SetValue)
  public setValue(ctx: StateContext<any>, { key, value }: SetValue): void {
    ctx.patchState({ [key]: value });
  }
}
